module.exports = __webpack_public_path__ + "static/media/savio33.7fc943fc.jpg";